import MessageInput from './message-input';

import Icons from 'assets/icons';

import { Box } from 'ui/box';
import { Stack } from 'ui/stack';

export interface MessageInputNoticeProps {
  notice: string;
  placeholder?: string;
}

const noop = (): void => {};

const MessageInputNotice = ({
  notice,
  placeholder = 'Ask something',
}: MessageInputNoticeProps) => (
  <Box sx={{ width: '100%' }}>
    <Stack
      direction="row"
      role="status"
      sx={{
        alignItems: 'center',
        gap: 1,
        borderTopLeftRadius: '0.5rem',
        borderTopRightRadius: '0.5rem',
        bgcolor: 'tokens.navy.50',
        px: 1.5,
        borderWidth: '1px',
        borderColor: 'tokens.navy.100',
        pt: 1.25,
        pb: '18px',
      }}
    >
      <Icons.CellInfo aria-hidden customClass="size-4 shrink-0 text-navy-600" />
      <span className="text-sm leading-none text-navy-800">{notice}</span>
    </Stack>

    <MessageInput
      onSendMessage={noop}
      disabled
      placeholder={placeholder}
      customClass="-mt-2"
    />
  </Box>
);

export default MessageInputNotice;
